import type { SVGProps, FC } from 'react'

import {
  WaterService,
  WaterServiceActive,
  PlumbingService,
  PlumbingServiceActive,
  SprinklerService,
  SprinklerServiceActive,
  CoolingService,
  CoolingServiceActive,
  VentilationService,
  VentilationServiceActive,
  FireProtectionService,
  FireProtectionServiceActive,
  PowerService,
  PowerServiceActive,
  LightingService,
  LightingServiceActive,
  GroundingService,
  GroundingServiceActive,
  AutomationService,
  AutomationServiceActive,
  CommunicationService,
  CommunicationServiceActive,
  VideoService,
  VideoServiceActive,
  IPService,
  IPServiceActive,
  ElectronicsService,
  ElectronicsServiceActive,
  TourniquetService,
  TourniquetServiceActive,
  IntercomService,
  IntercomServiceActive,
  AlarmService,
  AlarmServiceActive,
} from 'assets'

import rawContent from './servicesContent.json'

export type TLang = 'am' | 'en' | 'ru'

export type TServiceBlock = {
  type: 'step' | 'sub' | 'bullet' | 'para'
  text: string
  lead?: string
}

export type TServiceContent = {
  slug: string
  titles: Record<TLang, string>
  content: Record<TLang, TServiceBlock[]>
}

type TSVG = FC<SVGProps<SVGSVGElement>>

export type TServiceMeta = {
  slug: string
  Icon: TSVG
  HoverIcon: TSVG
  category: string
}

// Icon + category mapping, in display order (matches servicesContent.json order)
const meta: TServiceMeta[] = [
  { slug: 'water-supply', category: 'servicesCat1', Icon: WaterService, HoverIcon: WaterServiceActive },
  { slug: 'drainage', category: 'servicesCat1', Icon: PlumbingService, HoverIcon: PlumbingServiceActive },
  { slug: 'fire-suppression', category: 'servicesCat1', Icon: SprinklerService, HoverIcon: SprinklerServiceActive },
  { slug: 'heating-cooling', category: 'servicesCat2', Icon: CoolingService, HoverIcon: CoolingServiceActive },
  { slug: 'ventilation', category: 'servicesCat2', Icon: VentilationService, HoverIcon: VentilationServiceActive },
  { slug: 'smoke-control', category: 'servicesCat2', Icon: FireProtectionService, HoverIcon: FireProtectionServiceActive },
  { slug: 'power-supply', category: 'servicesCat3', Icon: PowerService, HoverIcon: PowerServiceActive },
  { slug: 'lighting', category: 'servicesCat3', Icon: LightingService, HoverIcon: LightingServiceActive },
  { slug: 'grounding-lightning', category: 'servicesCat3', Icon: GroundingService, HoverIcon: GroundingServiceActive },
  { slug: 'automation', category: 'servicesCat4', Icon: AutomationService, HoverIcon: AutomationServiceActive },
  { slug: 'networks-cabling', category: 'servicesCat4', Icon: CommunicationService, HoverIcon: CommunicationServiceActive },
  { slug: 'ip-telephony', category: 'servicesCat4', Icon: IPService, HoverIcon: IPServiceActive },
  { slug: 'tv-radio', category: 'servicesCat4', Icon: ElectronicsService, HoverIcon: ElectronicsServiceActive },
  { slug: 'video-surveillance', category: 'servicesCat5', Icon: VideoService, HoverIcon: VideoServiceActive },
  { slug: 'access-control', category: 'servicesCat5', Icon: TourniquetService, HoverIcon: TourniquetServiceActive },
  { slug: 'intercom', category: 'servicesCat5', Icon: IntercomService, HoverIcon: IntercomServiceActive },
  { slug: 'fire-alarm', category: 'servicesCat5', Icon: AlarmService, HoverIcon: AlarmServiceActive },
  { slug: 'intruder-alarm', category: 'servicesCat5', Icon: AlarmService, HoverIcon: AlarmServiceActive },
  { slug: 'evacuation', category: 'servicesCat5', Icon: AlarmService, HoverIcon: AlarmServiceActive },
  { slug: 'fire-automation', category: 'servicesCat5', Icon: FireProtectionService, HoverIcon: FireProtectionServiceActive },
]

const contentBySlug = (rawContent as unknown as TServiceContent[]).reduce<Record<string, TServiceContent>>((acc, item) => {
  acc[item.slug] = item

  return acc
}, {})

export type TService = TServiceMeta & TServiceContent

export const services: TService[] = meta
  .filter(m => contentBySlug[m.slug])
  .map(m => ({ ...m, ...contentBySlug[m.slug] }))

export const getService = (slug?: string): TService | undefined =>
  services.find(s => s.slug === slug)

export const serviceCategories: string[] = ['servicesCat1', 'servicesCat2', 'servicesCat3', 'servicesCat4', 'servicesCat5']

export const resolveLang = (lng?: string): TLang => {
  const base = (lng || 'am').slice(0, 2)

  return base === 'en' || base === 'ru' ? base : 'am'
}
